const API = {
  ANALYTICS_URL: 'reports/view',
  DIRECT_DEALS: 'directdeals',
  NETWORK_LINE_ITEMS_LISTING: 'networklineitems',
  ADX_LINE_ITEMS_LISTING: '/adxdeals',
  INHOUSE_PROMOTIONS_LISTING: 'promotions',
  SOURCE: 'asset',
};
Object.freeze(API);
export default API;
